import { graphic } from "../../Graphic";
import { TYPES } from "../../EntityManager";
import { Shape } from "../../helpers/Shape";
import { containerEvents } from "../../ContainerEvents";

export class MouseAreaSelection {

    constructor() {
        this.isActive = false;
        this.mouseArea = null;
        this.timer = null;
    }

    draw(initialPosition) {
        if (this.mouseArea) this.clear();

        const startX = initialPosition.x < containerEvents.mouseCoords.x
            ? initialPosition.x
            : containerEvents.mouseCoords.x;
        const endX = initialPosition.x < containerEvents.mouseCoords.x
            ? containerEvents.mouseCoords.x
            : initialPosition.x;
        const startY = initialPosition.y < containerEvents.mouseCoords.y
            ? initialPosition.y
            : containerEvents.mouseCoords.y;
        const endY = initialPosition.y < containerEvents.mouseCoords.y
            ? containerEvents.mouseCoords.y
            : initialPosition.y;

        if (startY === endY || startX === endX) return;

        this.mouseArea = Shape.createRectangle(startX, startY, endX, endY, Shape.selectionLineStyle, 0x4F84C4, 0.1);
        graphic.container.addChild(this.mouseArea);
        if (!this.timer) this.timer = setTimeout(() => {
            graphic.entityManager.forEach([TYPES.PIT, TYPES.TEXT, TYPES.ROW], entity => this.checkSelection(entity));
            clearTimeout(this.timer);
            this.timer = null;
        }, 100);
    }

    checkSelection(entity) {
        if (!this.mouseArea) return;

        let bounds = this.mouseArea.getBounds();
        bounds = {
            ...graphic.withTransformContainer(bounds),
            width: bounds.width / graphic.zoom,
            height: bounds.height / graphic.zoom
        };
        const entityPoints = entity.getBoundsPoints(true)
            .map(point =>
                graphic.withTransformContainer(entity.container.toGlobal(point)
                )
            );

        let inArea = entityPoints.some(point => (
            point.x > bounds.x &&
            point.y > bounds.y &&
            point.x < bounds.x + bounds.width &&
            point.y < bounds.y + bounds.height
        ));

        if (!inArea) {
            // https://stackoverflow.com/questions/9043805/test-if-two-lines-intersect-javascript-function
            // returns true if the line from (a,b)->(c,d) intersects with (p,q)->(r,s)
            const intersects = ({a, b}, {c, d}, {p, q}, {r, s}) => {
                let det, gamma, lambda;
                det = (c - a) * (s - q) - (r - p) * (d - b);
                if (det === 0) {
                    return false;
                } else {
                    lambda = ((s - q) * (r - a) + (p - r) * (s - b)) / det;
                    gamma = ((b - d) * (r - a) + (c - a) * (s - b)) / det;
                    return (0 < lambda && lambda < 1) && (0 < gamma && gamma < 1);
                }
            };

            const selectionPoints = [
                {x: bounds.x, y: bounds.y},
                {x: bounds.x + bounds.width, y: bounds.y},
                {x: bounds.x + bounds.width, y: bounds.y + bounds.height},
                {x: bounds.x, y: bounds.y + bounds.height}
            ];

            for (let i = 0; i < 4; i++) {
                const {x: a, y: b} = entityPoints[i];
                const {x: c, y: d} = entityPoints[i === 3 ? 0 : i + 1];
                for (let k = 0; k < 4; k++) {
                    const {x: p, y: q} = selectionPoints[k];
                    const {x: r, y: s} = selectionPoints[k === 3 ? 0 : k + 1];
                    inArea = intersects({a, b}, {c, d}, {p, q}, {r, s});
                    if (inArea) break;
                }
                if (inArea) break;
            }
        }

        if (inArea) {
            entity.drawSelectedArea();
            entity.isInMouseSelectionArea = true;
        } else {
            entity.clearSelectedArea();
            entity.isInMouseSelectionArea = false;
        }
    }

    getSelectedEntities() {
        let entities = graphic.entityManager.filter([TYPES.PIT, TYPES.TEXT, TYPES.ROW], entity => entity.isInMouseSelectionArea);
        return entities
    }

    clear() {
        graphic.container.removeChild(this.mouseArea);
        this.mouseArea.destroy();
        this.mouseArea = null;
    }

    destroy() {
        graphic.entityManager.forEach(null, entity => entity.isInMouseSelectionArea = false);
        if (this.mouseArea) this.clear();
        this.isActive = false;
    }
}